import React from "react";
import { useScrollReveal } from "../../hooks/useScrollReveal";

const EXPERIENCES = [
  {
    company: "INVIA Private Limited",
    role: "Senior Software Developer",
    duration: "Sep 2024 – Present",
    points: [
      "Leading cross-platform development in Flutter and native Kotlin using Clean Architecture for modularity, scalability, and long-term maintainability.",
      "Embedded AI-assisted tooling (Claude, Cursor) into the delivery pipeline, cutting manual coding time by 25% across the team.",
      "Designed and shipped agentic AI chatbot solutions for enterprise telecom clients — plan recommendations and SIM purchases with secure human-in-the-loop confirmation.",
      "Owning end-to-end Play Store and App Store release pipelines, sustaining 4.5★+ average ratings through strict quality gates, and mentoring junior engineers.",
    ],
  },
  {
    company: "EY (Ernst & Young)",
    role: "Senior Software Engineer (Contract)",
    duration: "Mar 2024 – Sep 2024",
    points: [
      "Engineered secure enterprise mobile apps in React Native with biometric authentication and role-based access control (RBAC).",
      "Applied AI-driven debugging workflows to resolve critical production incidents, improving system stability and reducing technical debt.",
      "Streamlined agile practices, increasing feature delivery velocity by 35%.",
    ],
  },
  {
    company: "Digimonk Pvt. Ltd.",
    role: "Software Engineer",
    duration: "Aug 2023 – Mar 2024",
    points: [
      "Built and maintained client-facing healthcare and e-learning apps in React Native with Firebase backend integration.",
      "Optimized app performance by 40% through refactoring, efficient state management, and optimized asset loading.",
      "Led internal project pods, consistently delivering high-quality features on schedule.",
    ],
  },
  {
    company: "Mavesys Infosoft Pvt. Ltd.",
    role: "Software Engineer",
    duration: "Mar 2022 – Aug 2023",
    points: [
      "Developed scalable enterprise mobile apps using React Native, Flutter, Java, and Kotlin.",
      "Reduced post-release bugs by 50% via comprehensive manual and automated testing strategies.",
      "Managed the full maintenance and update lifecycle for enterprise apps on Google Play Store.",
    ],
  }
];

function ExperienceSection() {
  const ref = useScrollReveal();

  return (
    <section className="portfolio-section about-section" id="experience" ref={ref}>
      <div className="chapter-section" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 2rem" }}>
        <span className="chapter-num reveal">03 — Career</span>
        <h2 className="section-title reveal reveal-delay-1">
          Work <span className="gradient-text">experience</span>
        </h2>
        <div className="timeline">
          {EXPERIENCES.map((exp, i) => (
            <div
              key={exp.company}
              className={`timeline-item reveal reveal-delay-${Math.min(i + 1, 3)}`}
            >
              <div className="timeline-card">
                <div className="timeline-company">{exp.company}</div>
                <div className="timeline-role">{exp.role}</div>
                <div className="timeline-duration">{exp.duration}</div>
                <ul className="timeline-desc">
                  {exp.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;
